import ReactGA from 'react-ga';

export const initGoogleAnalytics = (tag: string | undefined) => {
    if (tag === undefined) {
        return;
    }
    ReactGA.initialize(tag);
};
